export default __webpack_public_path__ + "static/media/blockquote.481d7d3c.svg";